export default __webpack_public_path__ + "static/lamina-81ca31295dc5c8d051460eb87e7af77d.png";